import React, { Component } from 'react';
import { CircularProgress } from 'material-ui-beta/Progress';
import Button from 'material-ui-beta/Button';
import Card from 'material-ui-beta/Card';
const ZonedDateTime = require('js-joda').ZonedDateTime;
import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui-beta/Dialog';
import Slide from 'material-ui-beta/transitions/Slide';

import api from '../../api/api';
import DropZone from '../dropzone/DropZone';

import './AdminResources.css';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class AdminResources extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            resources: null,
        };
    }

    componentDidMount() {
        this.fetchResources();
    }

    fetchResources() {
        api.getAdminResources().then(resources => {
            this.setState({
                loading: false,
                resources: resources
            })
        }).catch(err => {
            console.log(err);
            alert('Error fetching admin resources');
        })
    }

    isUserAdmin() {
        return this.props.user && this.props.user.isAdmin;
    }

    getAdminResources() {
        return this.state.resources || [];
    }

    render() {
        return (
            <div className="admin-resources-container flex">
                {this.isUserAdmin() ?
                    <div className="flex flex1 justifyCenter">
                        {this.state.loading ?
                            <CircularProgress size={50}/>
                            :
                            <div className="flex column flex1">
                                {this.getAdminResources().map((resource, index) => {
                                    return (
                                        <AdminResource resource={resource} key={"admin-resource-" + index} index={index} />
                                    )
                                })}
                            </div>
                        }
                    </div>
                    :
                    <div>Sorry, you do not have access to these Resources</div>
                }
            </div>
        )
    }

}


class AdminResource extends Component {

    constructor(props) {
        super(props);

        this.state = {
            uploading: false,
            showDialog: false
        }
    }

    onFileDrop = (file) => {
        this.file = file;

        this.setState({
            showDialog: true
        });
    };

    uploadFile = (notify) => {
        this.setState({
            uploading: true,
            showDialog: false
        });

        api.uploadAdminResource(this.file, this.props.resource, this.props.index).then(update => {
            this.props.resource.downloadUrl = update.downloadUrl;
            this.props.resource.lastUpdated = update.lastUpdated;
        }).then(() => {
            if (notify) {
                return api.createAdminResourceNotifyEvent(this.props.resource)
            }
        }).then(() => {
            this.setState({
                uploading: false
            });
        }).catch(err => {
            // TODO: Show dialog
            alert('error');
            console.error(err);
        })
    };

    onViewResourceClick = () => {
        window.open(this.props.resource.downloadUrl);
    };

    getLastUpdatedDate(lastUpdated) {
        if (lastUpdated) {
            let date = ZonedDateTime.parse(lastUpdated);
            return `${date.month().value()}/${date.dayOfMonth()}/${date.year()} @ ${date.hour()}:${date.minute()}`;
        }
    }

    handleClose = () => {
        this.setState({
            showDialog: false
        });
    };

    render() {
        return (
            <div className="admin-resource-container flex1">
                <div className="admin-resource-title oswald">
                    {this.props.resource.title}
                </div>
                <Card>
                    <div>
                        <DropZone
                            accepts=".xlsx,.xls"
                            uploading={this.state.uploading}
                            onDrop={this.onFileDrop} />
                    </div>
                </Card>
                <div className="admin-resource-last-updated flex">
                    <div className="flex centerBoth">
                        Last Updated on {this.props.resource.lastUpdated ? this.getLastUpdatedDate(this.props.resource.lastUpdated) : "N/A"}
                    </div>
                    {this.props.resource.downloadUrl ?
                        <div className="admin-resource-download-url">
                            <Button color="primary" onClick={this.onViewResourceClick}>View Resource</Button>
                        </div>
                        :
                        null
                    }
                </div>
                <Dialog
                    open={this.state.showDialog}
                    transition={Transition}
                    onClose={this.handleClose}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="flex1 oswald admin-member-resource-dialog-title">
                            Update or New Resource?
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            Is this an Update (won't notify users) or New Resource (will notify users who have paid for this resource)?
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">Cancel</Button>
                        <Button onClick={this.uploadFile.bind(null, false)} color="primary">Update</Button>
                        <Button onClick={this.uploadFile.bind(null, true)} color="primary">New</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }


}

export default AdminResources;


// WEBPACK FOOTER //
// ./src/components/admin-resources/AdminResources.js